module.exports = __webpack_public_path__ + "static/media/portfolio-whiteboard-gif-500.c0eed937.gif";